import axios from "axios";
import { removeItem } from "./storage";
import {IMPERSONATIONTOKEN, IMPERSONATIONUSER} from "../state/auth";
import {navigateToUrl} from "../utils/helpers";

export const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response:any) => {
     const expired = response.headers["x-impersonation-expired"];

      if (response.headers["x-impersonation-expired"] && expired === "true") {
        removeItem(IMPERSONATIONTOKEN);
        removeItem(IMPERSONATIONUSER);

        // Notify UI
        window.location.href = "/associated-chains";
      }

      return response;
    },
    (error:any) => {
      // Optional: handle 401 impersonation errors
      if (error?.response?.headers?.["x-impersonation-expired"] === "true") {
        removeItem(IMPERSONATIONTOKEN);
        removeItem(IMPERSONATIONUSER);
        window.location.href = "/associated-chains";
      }

      return Promise.reject(error);
    }
  );
};
